import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { CockpitPeriodKey, IEnrichedCockpitFinSobRow } from '../model/types'

import { getCockpitPeriodQuarters } from './getCockpitPeriodQuarters'

interface IParams {
  currentFQuarter: number
  rows: IEnrichedCockpitFinSobRow[]
  offering: ProgramTypes
  periods: CockpitPeriodKey[]
  category: string | null
}

/** Fin/SOB rows scoped to the selected offering, period, and category. Offering is compared the
 *  same trimmed way as `selectCockpitFinSobRows`: `offering === null` rolls every offering up
 *  together. `category === null` rolls every category up together. The period covers quarters
 *  `1`-`4` only (see `getCockpitPeriodQuarters`), which is what keeps the full-year total row
 *  (quarter `5`) out of the result. */
export const getFilteredFinSobRows = ({
  currentFQuarter,
  rows,
  offering,
  periods,
  category,
}: IParams): IEnrichedCockpitFinSobRow[] => {
  const quarters = new Set(getCockpitPeriodQuarters(periods, currentFQuarter))

  return rows
    .filter((row) => quarters.has(row.fQuarter))
    .filter((row) => {
      if (offering === ProgramTypes.Overall) {
        return true
      }

      return row.offering.trim() === offering.trim()
    })
    .filter((row) => {
      if (category === null) {
        return true
      }

      return row.category === category
    })
}
